import { MrModalDialog } from '@mrhenry/wp--mr-interactive';

class MrNavigationOverlay extends MrModalDialog {
	override async willOpen() {
		await super.willOpen();

		document.body.classList.add( 'has-open-overlay' );
	}

	override async willClose() {
		await super.willClose();

		document.body.classList.remove( 'has-open-overlay' );
	}

	override openAnimations() {
		if ( !( 'KeyframeEffect' in window ) ) {
			return [];
		}

		const keyframeEffects:KeyframeEffect[] = [];
		const menuItems = this.querySelectorAll( '.navigation-overlay__menu__list__item' );

		if ( menuItems ) {
			menuItems.forEach( ( item, index ) => {
				keyframeEffects[index] = new KeyframeEffect(
					item,
					[
						{
							transform: 'skew(85deg) translate3d(250px, 0, 0)',
							opacity: 0,
						},
						{
							transform: 'skew(0deg) translate3d(0, 0, 0)',
							opacity: 1,
						},
					],
					{
						duration: 128,
						delay: index * 96 + 196,
						easing: 'ease-out',
						fill: 'forwards',
					}
				);
			} );
		}

		return [
			new KeyframeEffect(
				this,
				[
					{
						opacity: 0,
					},
					{
						opacity: 1,
					},
				],
				{
					duration: 256,
					easing: 'ease-out',
					fill: 'forwards',
				}
			),
			...keyframeEffects,
			new KeyframeEffect(
				this.querySelector( '.social-links' ),
				[
					{
						transform: 'skew(85deg) translate3d(250px, 0, 0)',
						opacity: 0,
					},
					{
						transform: 'skew(0deg) translate3d(0, 0, 0)',
						opacity: 1,
					},
				],
				{
					duration: 128,
					delay: menuItems.length * 96 + 196,
					easing: 'ease-out',
					fill: 'forwards',
				}
			),
		];
	}

	override closeAnimations() {
		if ( !( 'KeyframeEffect' in window ) ) {
			return [];
		}

		const keyframeEffects:KeyframeEffect[] = [];
		const menuItems = this.querySelectorAll( '.navigation-overlay__menu__list__item' );

		if ( menuItems ) {
			menuItems.forEach( ( item, index ) => {
				keyframeEffects[index] = new KeyframeEffect(
					item,
					[
						{
							transform: 'skew(0deg) translate3d(0, 0, 0)',
							opacity: 1,
						},
						{
							transform: 'skew(85deg) translate3d(-250px, 0, 0)',
							opacity: 0,
						},
					],
					{
						duration: 128,
						delay: index * 96,
						easing: 'ease-in',
						fill: 'forwards',
					}
				);
			} );
		}

		return [
			...keyframeEffects,
			new KeyframeEffect(
				this.querySelector( '.social-links' ),
				[
					{
						transform: 'skew(0deg) translate3d(0, 0, 0)',
						opacity: 1,
					},
					{
						transform: 'skew(85deg) translate3d(-250px, 0, 0)',
						opacity: 0,
					},
				],
				{
					duration: 128,
					delay: menuItems.length * 96,
					easing: 'ease-out',
					fill: 'forwards',
				}
			),
			new KeyframeEffect(
				this,
				[
					{
						opacity: 1,
					},
					{
						opacity: 0,
					},
				],
				{
					duration: 196,
					delay: 256,
					easing: 'ease-in',
					fill: 'forwards',
				}
			),
		];
	}
}

customElements.define( 'mr-navigation-overlay', MrNavigationOverlay );
